import React from 'react';
import SuperAdminSidebar from '../components/SuperAdminSidebar';
import AdminTopBar from '../components/AdminTopBar';
import EvaluationBuilder from '../EvaluationBuilder';
import { API_ENDPOINTS } from '../config/api';

const InstitutionalEvaluationBuilderPage = ({ isEdit = false }) => {
  const breadcrumbItems = [
    { href: '/institutional-admin/dashboard', label: 'Dashboard' },
    { href: '/institutional-admin/evaluations', label: 'Evaluations' },
    { label: isEdit ? 'Edit template' : 'New template' },
  ];

  return (
    <div className="d-flex vh-100">
      <SuperAdminSidebar variant="institutional" />
      <div className="d-flex flex-column flex-grow-1">
        <AdminTopBar variant="institutional" breadcrumbItems={breadcrumbItems} />
        <div className="flex-grow-1" style={{ height: 'calc(100vh - 61px)' }}>
          <div className="container-fluid p-0 overflow-hidden" style={{ height: '100%' }}>
            <EvaluationBuilder
              isEdit={isEdit}
              apiBase={API_ENDPOINTS.INSTITUTIONAL_ADMIN}
              embedded
              plainSidebar
              skipInitialTemplateModal
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default InstitutionalEvaluationBuilderPage;
